<div
  class="business-information-container"
  [formGroup]="accountBusinessInfoForm">
  <mat-form-field
    *ngFor="let field of formFields"
    class="mat-md"
    appearance="outline">
    <mat-label>{{ field.label }}</mat-label>
    <input
      *ngIf="
        field.id !== 'FEINNumber' &&
        field.id !== 'stateTaxId' &&
        field.id !== 'paymentTerms'
      "
      matInput
      formControlName="{{ field.id }}"
      (blur)="dipatchBusinessFormChanges()" />
    <input
      *ngIf="field.id === 'FEINNumber'"
      matInput
      numbersWithHyphen
      [formatAsFein]="true"
      formControlName="{{ field.id }}"
      (blur)="dipatchBusinessFormChanges()" />
    <input
      *ngIf="field.id === 'stateTaxId'"
      matInput
      numbersWithHyphen
      [formatAsFein]="false"
      formControlName="{{ field.id }}"
      (blur)="dipatchBusinessFormChanges()" />
    <div
      *ngIf="
        field.type === formFieldType.select && field.id === 'paymentTerms'
      ">
      <input
        id="businessInfoPaymentTerms"
        appOnOptionSelectedTabNewInput
        matInput
        formControlName="paymentTerms"
        [required]="field.required === true"
        [matAutocomplete]="paymentTermsAutoComplete"
        (input)="onPaymentTermsInput($event)"
        (keydown)="onPaymentTermsKeydown($event)"
        (paste)="onPaymentTermsPaste($event)"
        placeholder="Enter numeric value or select from dropdown" />
      <mat-autocomplete
        #paymentTermsAutoComplete="matAutocomplete"
        (optionSelected)="onPaymentTermsAutocompleteSelection()"
        appOnOptionSelectedTabNewInput
        [controlId]="'businessInfoPaymentTerms'">
        <mat-option
          *ngFor="let item of filterPaymentTermsOption | async"
          [value]="item.name">
          {{ item.name }}
        </mat-option>
      </mat-autocomplete>
    </div>
    <app-field-clear-suffix
      matSuffix
      *ngIf="field.type === formFieldType.select && field.id === 'paymentTerms'"
      [control]="accountBusinessInfoForm.get('paymentTerms')"
      [autocomplete]="true" />
    <app-svg-icon
      *ngIf="checkControlForError(field.id)"
      matSuffix
      [iconName]="'infoCircle'"
      [isStaticSvg]="true"
      class="cursor info-icon-error"
      (click)="fetchWidth($event, field.id)"
      (keydown)="$event.stopPropagation()"></app-svg-icon>
    <app-custom-error-tooltip
      *ngIf="
        checkControlForError(field.id) && setBusinessInfoErrorTooltip[field.id]
      "
      [tooltipWidth]="setBusinessInfoWidth[field.id]"
      [tooltipText]="fetchErrorMessages(field.id)"
      (tooltipCloseClicked)="
        commonService.closeErrorTooltip(field.id, setBusinessInfoErrorTooltip)
      ">
    </app-custom-error-tooltip>
  </mat-form-field>
</div>
